const tableMoudel = {
  data() {
    return {
      pageInfo: {
        page: 1,
        limit: 10
      },
      total: 0,
      loading: false,
      pageSizes:[10, 20, 50, 100],
      tableData: []
    }
  },
  methods: {
    fliteRData(row, column, cellValue, index) {
      const _value = row[column.property]
      if (_value) {
        return _value
      } else {
        return '--'
      }
    },
    search() {
      this.pageInfo.page = 1
      this.getData()
    },
    reset(formName) {
      this.pageInfo.page = 1
      this.$nextTick(() => {
        this.$refs[formName].resetFields()
        this.getData('init')
      })
    },
    handleSizeChange(val) {
      this.pageInfo.limit = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val
      this.getData()
    },
    dateFormat(fmt, date) {
      let ret
      const opt = {
        'Y+': date.getFullYear().toString(), // 年
        'm+': (date.getMonth() + 1).toString(), // 月
        'd+': date.getDate().toString(), // 日
        'H+': date.getHours().toString(), // 时
        'M+': date.getMinutes().toString(), // 分
        'S+': date.getSeconds().toString() // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
      }
      for (let k in opt) {
        ret = new RegExp('(' + k + ')').exec(fmt)
        if (ret) {
          fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, '0')))
        };
      };
      return fmt
    },
    IntValue(e, index) {
      const maxLength = e.target.maxLength
      let value = e.target.value
      if (!(/(^[1-9]\d*$)/.test(value))) {
        value = value.replace(/[^\d]/g, '')
      }
      if (maxLength) {
        return value.slice(0, maxLength)
      } else {
        return value
      }
    },
    modalInt(name, row) {
      this.$refs[name].init(row)
    }
  }
}

export default tableMoudel
